import React, { useEffect, useContext } from 'react';
import { EyeFilled, EyeInvisibleFilled } from '@ant-design/icons';
import { Form, Input, Alert } from 'antd';
import classNames from 'classnames';
import { Link, useNavigate } from 'react-router-dom';
import { useWindowSize } from 'react-use';

import OmiButton from 'components/@Omini/OmiButton';
import BranchIntro from 'components/Auth/BranchIntro';
import { MIN_MD } from 'constants/ThemeSetting';
import { hideMessage, signIn } from 'store/actions/AuthAction';
import { AuthContext } from 'store/context';

function SignIn() {
  const navigate = useNavigate();
  const { width } = useWindowSize();
  const {
    AuthState: { loading, message, error, token },
    AuthDispatch,
  } = useContext(AuthContext);

  useEffect(() => {
    if (token !== null) {
      navigate('/');
    }
  }, [token]);

  const handleSubmit = async values => {
    await signIn({ payload: values, dispatch: AuthDispatch });
  };

  const formBtnSumitClasses = classNames({
    'omi-auth-form-submit': true,
    'mt-10 md:mt-16': !error,
  });
  const alertClasses = classNames({
    'omi-auth-alert': true,
    'flex items-center mt-8 md:mt-12': error,
    hidden: !error,
  });
  const alertSuccessClasses = classNames({
    'omi-auth-alert': true,
    'flex items-center mt-8 md:mt-12': message,
    hidden: !message,
  });

  return (
    <div className="flex flex-col lg:flex-row lg:h-auto">
      <div className="omi-auth-layout-title">
        <BranchIntro />
      </div>
      <div className="omi-auth-layout-content">
        <div className="flex lg:h-full flex-col justify-start items-center p-6 py-12 lg:justify-center lg:p-0 ">
          <div className="omi-auth-form login-container">
            <p className="omi-auth-form-title">Đăng nhập</p>
            <Form name="login" onFinish={handleSubmit} size={width >= MIN_MD ? 'large' : 'middle'} layout="vertical">
              <Form.Item
                label="Email"
                name="email"
                rules={[
                  {
                    type: 'email',
                    message: 'Định dạng email không đúng. Vui lòng kiểm tra lại.',
                  },
                  {
                    required: true,
                    message: 'Yêu cầu nhập email.',
                  },
                ]}
              >
                <Input placeholder="hello@omini.vn" />
              </Form.Item>
              <Form.Item
                label="Mật khẩu"
                name="password"
                rules={[{ required: true, message: 'Yêu cầu nhập mật khẩu.' }]}
              >
                <Input.Password
                  iconRender={visible =>
                    visible ? <EyeFilled width={18} height={18} /> : <EyeInvisibleFilled width={18} height={18} />
                  }
                  placeholder="Mật khẩu"
                />
              </Form.Item>

              <Form.Item className={formBtnSumitClasses}>
                <Alert className={alertClasses} message={error} type="error" showIcon />
                <Alert className={alertSuccessClasses} message={message} type="success" showIcon />
                <OmiButton type="primary" htmlType="submit" block loading={loading}>
                  Đăng nhập
                </OmiButton>
              </Form.Item>

              <div className="flex justify-between">
                <Link
                  to="/forgot-password"
                  onClick={() => AuthDispatch(hideMessage())}
                  className="f-semibold text-grey-700 text-xs sm:text-sm "
                >
                  Quên mật khẩu?
                </Link>
                <Link
                  to="/signup"
                  onClick={() => AuthDispatch(hideMessage())}
                  className="f-semibold text-grey-700 text-xs sm:text-sm "
                >
                  Chưa có tài khoản?
                </Link>
              </div>
            </Form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SignIn;
